<template>
	<div class="charts-wrapper">
		<AppChart
			ref="chart-gross-volume"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('orders_total')"
			:caption="getString('total')"
			:value="allSeries.volumeTotal"
			:last-period-value="allSeries.volumeTotalPrevious"
			:colors="['#dadada', '#6c33cb']"
			:series="allSeries.globalVolume"
			:xaxis="xaxisTimes.map(time => time.label)"
			:formatter="r => readableEurValue(r || 0, 0)"
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-orders-volume"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('orders_volume')"
			:caption="getString('total')"
			:value="allSeries.countTotal"
			:last-period-value="allSeries.countTotalPrevious"
			:colors="['#dadada', '#6c33cb']"
			:series="allSeries.globalOrders"
			:xaxis="xaxisTimes.map(time => time.label)"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-transactions-volume"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('transactions_volume')"
			:caption="getString('total')"
			:value="allSeries.transactionsVolumeTotal"
			:last-period-value="allSeries.transactionsVolumeTotalPrevious"
			:colors="['#dadada', '#6c33cb']"
			:series="allSeries.transactionsVolume"
			:xaxis="xaxisTimes.map(time => time.label)"
			:formatter="r => readableEurValue(r || 0, 0)"
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-transactions-quantity"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('transactions_quantity')"
			:caption="getString('total')"
			:value="allSeries.transactionsCountTotal"
			:last-period-value="allSeries.transactionsCountTotalPrevious"
			:colors="['#dadada', '#6c33cb']"
			:series="allSeries.transactionsCount"
			:xaxis="xaxisTimes.map(time => time.label)"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-menu-views"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('menu_views')"
			:caption="getString('views')"
			:value="viewsSeries.viewsTotal"
			:last-period-value="viewsSeries.viewsTotalPrevious"
			:colors="['#dadada', '#6c33cb']"
			:series="viewsSeries.viewsSeries"
			:xaxis="xaxisTimes.map(time => time.label)"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-menu-users"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('menu_users')"
			:caption="getString('users')"
			:value="viewsSeries.usersTotal"
			:last-period-value="viewsSeries.usersTotalPrevious"
			:colors="['#dadada', '#6c33cb']"
			:series="viewsSeries.usersSeries"
			:xaxis="xaxisTimes.map(time => time.label)"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			v-if="!isAggregateOnly"
			ref="chart-businesses-volume"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('volume_businesses_chart')"
			:caption="allSeries.bestBusinessVolumeName"
			:value="allSeries.bestBusinessVolume"
			:last-period-value="allSeries.bestBusinessVolumePrevious"
			:colors="allSeries && allSeries.bestBusinessVolumeColors ? allSeries.bestBusinessVolumeColors : ['#6c33cb']"
			:series="allSeries.businessesVolume"
			:xaxis="xaxisTimes.map(time => time.label)"
			type="area"
			:formatter="r => readableEurValue(r || 0, 0)"
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			v-if="!isAggregateOnly"
			ref="chart-businesses-orders"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:title="getString('orders_businesses_chart')"
			:caption="allSeries.bestBusinessOrdersName"
			:value="allSeries.bestBusinessOrders"
			:last-period-value="allSeries.bestBusinessOrdersPrevious"
			:colors="allSeries && allSeries.bestBusinessOrdersColors ? allSeries.bestBusinessOrdersColors : ['#6c33cb']"
			:series="allSeries.businessesOrders"
			:xaxis="xaxisTimes.map(time => time.label)"
			type="area"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-mode-volume"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:caption="allSeries.bestOrderModeVolumeName"
			:value="allSeries.bestOrderModeVolume"
			:last-period-value="allSeries.bestOrderModeVolumePrevious"
			:title="getString('volume_mode_chart')"
			:colors="allSeries.modesColors"
			:series="allSeries.ordersModesVolume"
			:xaxis="xaxisTimes.map(time => time.label)"
			type="area"
			:formatter="r => readableEurValue(r || 0, 0)"
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-mode-orders"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:caption="allSeries.bestOrderModeOrdersName"
			:value="allSeries.bestOrderModeOrders"
			:last-period-value="allSeries.bestOrderModeOrdersPrevious"
			:title="getString('orders_mode_chart')"
			:colors="allSeries.modesColors"
			:series="allSeries.ordersModesOrders"
			:xaxis="xaxisTimes.map(time => time.label)"
			type="area"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-type-volume"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:caption="allSeries.bestPaymentVolumeName"
			:value="allSeries.bestPaymentVolume"
			:last-period-value="allSeries.bestPaymentVolumePrevious"
			:title="getString('volume_types_chart')"
			:colors="allSeries.paymentsColors"
			:series="allSeries.paymentsVolume"
			:xaxis="xaxisTimes.map(time => time.label)"
			type="area"
			:formatter="r => readableEurValue(r || 0, 0)"
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
		<AppChart
			ref="chart-type-orders"
			expandible
			height="100%"
			full-width
			:top-scroll-diff="selectorsRowHeight"
			:caption="allSeries.bestPaymentOrdersName"
			:value="allSeries.bestPaymentOrders"
			:last-period-value="allSeries.bestPaymentOrdersPrevious"
			:title="getString('orders_types_chart')"
			:colors="allSeries.paymentsColorsNum"
			:series="allSeries.paymentsOrders"
			:xaxis="xaxisTimes.map(time => time.label)"
			type="area"
			no-currency
			:dark="userStore.darkMode"
			:force-y-axis-zero="true"
		/>
	</div>
</template>

<script>
import AppChart from "@/shared/components/AppChart.vue";

import WindowWidth from "@/console-new/mixins/WindowWidth";

import {useLanguageStore, useValuesStore} from "@/shared/stores";
import {useAnalyticsStore} from "@/console-new/stores";
import {useSuperStore, useUserStore} from "@/user/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const analyticsStore = useAnalyticsStore();
		const superStore = useSuperStore();
		const valuesStore = useValuesStore();
		const userStore = useUserStore();
		return {languageStore, getString: languageStore.getString, analyticsStore, superStore, readableEurValue: languageStore.readableEurValue, valuesStore, userStore};
	},
	name: "UserChartsAggregated",
	components: { AppChart },
	mixins: [WindowWidth],
	data() {
		return {
			cardNetworks: {
				mastercard: {
					name: 'Mastercard',
					color: '#FF5F00'
				},
				visa: {
					name: 'Visa',
					color: '#1a1f71'
				},
				amex: {
					name: 'Amex',
					color: '#016FD0'
				},
				unionpay: {
					name: 'UnionPay',
					color: '#dd0227'
				},
				cartes_bancaires: {
					name: 'Cartes Bancaires',
					color: '#008080'
				},
				other: {
					name: 'Other',
					color: '#6c33cb'
				},
			},
			cardFundings: {
				credit: {
					name: 'Credit',
					color: '#FDC700'
				},
				debit: {
					name: 'Debit',
					color: '#fd8700'
				},
				prepaid: {
					name: 'Prepaid',
					color: '#1da4f8'
				},
				other: {
					name: 'Other',
					color: '#6c33cb'
				},
			},
		};
	},
	props: {
		aggregatedData: {
			type: Object,
			default: () => ({
				full: [],
				type: [],
				mode: []
			})
		},
		previousAggregatedData: {
			type: Object,
			default: () => ({
				full: [],
				type: [],
				mode: []
			})
		},
		views: {
			type: Array,
			default: () => []
		},
		previousViews: {
			type: Array,
			default: () => []
		},
		periodDates: {
			type: Object,
			default: null
		},
		timeGrain: {
			type: String,
			default: 'day'
		},
		bucketColumn: {
			type: String,
			default: 'day_bucket'
		},
		isAggregateOnly: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		ordersModes() {
			return this.valuesStore.ordersModes;
		},
		xaxisTimes() {
			return this.analyticsStore.xaxisTimesAggregated(this.periodDates);
		},
		selectorsRowHeight() {
			return this.windowWidth > 820 ? 80 : this.windowWidth > 420 ? 150 : 190;
		},
		viewsSeries() {
			let result = {
				viewsTotal: 0,
				viewsTotalPrevious: 0,
				usersTotal: 0,
				usersTotalPrevious: 0,
			}

			let zeroSeries = this.xaxisTimes.map(time => 0);
			let viewsSeries = [{
				name: this.getString('previous_period'),
				data: zeroSeries
			}, {
				name: this.getString('current_period'),
				data: Object.assign([], zeroSeries)
			}];
			let usersSeries = [{
				name: this.getString('previous_period'),
				data: Object.assign([], zeroSeries)
			}, {
				name: this.getString('current_period'),
				data: Object.assign([], zeroSeries)
			}];

			let activeChart = {
				viewsSeries: false,
			};

			let datesIndex = 0;
			this.views.forEach(view => {
				datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, view);

				if (datesIndex !== -1) {

					if (typeof viewsSeries[1].data[datesIndex] !== 'undefined') {
						viewsSeries[1].data[datesIndex] += view.visits_count;
					}
					if (typeof usersSeries[1].data[datesIndex] !== 'undefined') {
						usersSeries[1].data[datesIndex] += view.users_count;
					}
					result.viewsTotal += view.visits_count;
					result.usersTotal += view.users_count;

                    activeChart.viewsSeries = true;
				}
			});


			datesIndex = 0;
			this.previousViews.forEach(view => {
				datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, view, true);

				if (datesIndex !== -1) {

					if (typeof viewsSeries[0].data[datesIndex] !== 'undefined') {
						viewsSeries[0].data[datesIndex] += view.visits_count;
					}
					if (typeof usersSeries[0].data[datesIndex] !== 'undefined') {
						usersSeries[0].data[datesIndex] += view.users_count;
					}
					result.viewsTotalPrevious += view.visits_count;
					result.usersTotalPrevious += view.users_count;

					activeChart.viewsSeries = true;
				}
			});

			// Check if viewsSeries has any non-zero data
			const viewsHasData = activeChart.viewsSeries && 
				(viewsSeries[0].data.some(v => v > 0) || viewsSeries[1].data.some(v => v > 0));
			
			// Check if usersSeries has any non-zero data
			const usersHasData = activeChart.viewsSeries && 
				(usersSeries[0].data.some(v => v > 0) || usersSeries[1].data.some(v => v > 0));

			return {
				viewsTotal: result.viewsTotal,
				viewsTotalPrevious: result.viewsTotalPrevious,
				usersTotal: result.usersTotal,
				usersTotalPrevious: result.usersTotalPrevious,
				viewsSeries: viewsHasData ? viewsSeries : [],
				usersSeries: usersHasData ? usersSeries : [],
			}
		},
		allSeries() {
			let result = {
				volumeTotal: 0,
				volumeTotalPrevious: 0,
				countTotal: 0,
				countTotalPrevious: 0,
				transactionsVolumeTotal: 0,
				transactionsVolumeTotalPrevious: 0,
				transactionsCountTotal: 0,
				transactionsCountTotalPrevious: 0,
				bestBusinessVolumeName: '',
				bestBusinessVolume: 0,
				bestBusinessVolumePrevious: 0,
				bestBusinessVolumeColors: ['#6c33cb'],
				bestBusinessOrdersName: '',
				bestBusinessOrders: 0,
				bestBusinessOrdersPrevious: 0,
				bestBusinessOrdersColors: ['#6c33cb'],
				bestPaymentVolumeName: '',
				bestPaymentVolume: 0,
				bestPaymentVolumePrevious: 0,
				bestPaymentOrdersName: '',
				bestPaymentOrders: 0,
				bestPaymentOrdersPrevious: 0,
				bestOrderModeVolumeName: '',
				bestOrderModeVolume: 0,
				bestOrderModeVolumePrevious: 0,
				bestOrderModeOrdersName: '',
				bestOrderModeOrders: 0,
				bestOrderModeOrdersPrevious: 0,
				modesColors: [],
				paymentsColors: [],
				paymentsColorsNum: [],
			};

			// Initialize time series
			let zeroSeries = this.xaxisTimes.map(time => 0);
			let globalVolume = [{
				name: this.getString('previous_period'),
				data: Object.assign([], zeroSeries)
			}, {
				name: this.getString('current_period'),
				data: Object.assign([], zeroSeries)
			}];
			let globalOrders = [{
				name: this.getString('previous_period'),
				data: Object.assign([], zeroSeries)
			}, {
				name: this.getString('current_period'),
				data: Object.assign([], zeroSeries)
			}];
			let transactionsVolume = [{
				name: this.getString('previous_period'),
				data: Object.assign([], zeroSeries)
			}, {
				name: this.getString('current_period'),
				data: Object.assign([], zeroSeries)
			}];
			let transactionsCount = [{
				name: this.getString('previous_period'),
				data: Object.assign([], zeroSeries)
			}, {
				name: this.getString('current_period'),
				data: Object.assign([], zeroSeries)
			}];

			// Initialize series objects for different dimensions
			let businessesVolumeSeries = {};
			let businessesOrdersSeries = {};
			let paymentsVolumeSeries = {};
			let paymentsOrdersSeries = {};
			let ordersModesVolumeSeries = {};
			let ordersModesOrdersSeries = {};

			// Process current period aggregated data
			if (this.aggregatedData && this.aggregatedData.full) {
				// Process full dimension data for global totals
				this.aggregatedData.full.forEach(row => {
					const bucket = new Date(row[this.bucketColumn]);
					// Adjust bucket time to match xaxisTimes to prevent date shifting
					if (this.xaxisTimes.length > 0 && this.bucketColumn !== 'hour_bucket') {
						bucket.setHours(this.xaxisTimes[0].rawDate.getHours(), this.xaxisTimes[0].rawDate.getMinutes(), 0, 0);
					}
					const datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, {date: bucket});
					
					if (datesIndex !== -1) {
						const grossSales = row.gross_sales / 100;
						const ordersCount = row.orders_cnt;
						
						// Update global series
						globalVolume[1].data[datesIndex] += grossSales;
						globalOrders[1].data[datesIndex] += ordersCount;
						
						// Update totals
						result.volumeTotal += grossSales;
						result.countTotal += ordersCount;
						
						// Update business series (only if not aggregate-only)
						if (!this.isAggregateOnly && row.business_id) {
							const businessId = row.business_id;
							if (!businessesVolumeSeries[businessId]) {
								// Find business name from superStore
								const business = this.superStore.businesses ? this.superStore.businesses.find(b => b.business_id === parseInt(businessId)) : null;
								const businessName = business ? business.name : `Business ${businessId}`;
								businessesVolumeSeries[businessId] = {
									business_id: businessId,
									name: businessName,
									data: Object.assign([], zeroSeries)
								};
								businessesOrdersSeries[businessId] = {
									business_id: businessId,
									name: businessName,
									data: Object.assign([], zeroSeries)
								};
							}
							businessesVolumeSeries[businessId].data[datesIndex] += grossSales;
							businessesOrdersSeries[businessId].data[datesIndex] += ordersCount;
						}
					}
				});
				
				// Process payment type dimension
				if (this.aggregatedData.type) {
					this.aggregatedData.type.forEach(row => {
						const bucket = new Date(row[this.bucketColumn]);
						// Adjust bucket time to match xaxisTimes to prevent date shifting
						if (this.xaxisTimes.length > 0 && this.bucketColumn !== 'hour_bucket') {
							bucket.setHours(this.xaxisTimes[0].rawDate.getHours(), this.xaxisTimes[0].rawDate.getMinutes(), 0, 0);
						}
						const datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, {date: bucket});
						
						if (datesIndex !== -1) {
							const paymentType = row.payment_type;
							const grossSales = row.gross_sales / 100;
							const ordersCount = row.orders_cnt;
							
							if (!paymentsVolumeSeries[paymentType]) {
								paymentsVolumeSeries[paymentType] = {
									payment_method: paymentType,
									name: this.valuesStore.paymentsMethods[paymentType]?.name || paymentType,
									color: this.valuesStore.paymentsMethods[paymentType]?.color || "#0752A3",
									data: Object.assign([], zeroSeries)
								};
								paymentsOrdersSeries[paymentType] = {
									payment_method: paymentType,
									name: this.valuesStore.paymentsMethods[paymentType]?.name || paymentType,
									color: this.valuesStore.paymentsMethods[paymentType]?.color || "#0752A3",
									data: Object.assign([], zeroSeries)
								};
							}
							paymentsVolumeSeries[paymentType].data[datesIndex] += grossSales;
							paymentsOrdersSeries[paymentType].data[datesIndex] += ordersCount;
							
							// Add to transactions series if payment type is 'stripe'
							if (paymentType === 'stripe') {
								transactionsVolume[1].data[datesIndex] += grossSales;
								transactionsCount[1].data[datesIndex] += ordersCount;
								result.transactionsVolumeTotal += grossSales;
								result.transactionsCountTotal += ordersCount;
							}
						}
					});
				}
				
				// Process order mode dimension
				if (this.aggregatedData.mode) {
					this.aggregatedData.mode.forEach(row => {
						const bucket = new Date(row[this.bucketColumn]);
						// Adjust bucket time to match xaxisTimes to prevent date shifting
						if (this.xaxisTimes.length > 0 && this.bucketColumn !== 'hour_bucket') {
							bucket.setHours(this.xaxisTimes[0].rawDate.getHours(), this.xaxisTimes[0].rawDate.getMinutes(), 0, 0);
						}
						const datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, {date: bucket});
						
						if (datesIndex !== -1) {
							const orderMode = row.order_mode;
							const grossSales = row.gross_sales / 100;
							const ordersCount = row.orders_cnt;
							
							if (!ordersModesVolumeSeries[orderMode]) {
								ordersModesVolumeSeries[orderMode] = {
									order_mode: orderMode,
									name: this.ordersModes[orderMode]?.name || orderMode,
									data: Object.assign([], zeroSeries)
								};
								ordersModesOrdersSeries[orderMode] = {
									order_mode: orderMode,
									name: this.ordersModes[orderMode]?.name || orderMode,
									data: Object.assign([], zeroSeries)
								};
							}
							ordersModesVolumeSeries[orderMode].data[datesIndex] += grossSales;
							ordersModesOrdersSeries[orderMode].data[datesIndex] += ordersCount;
						}
					});
				}
			}

			// Process previous period aggregated data
			if (this.previousAggregatedData && this.previousAggregatedData.full) {
				this.previousAggregatedData.full.forEach(row => {
					const bucket = new Date(row[this.bucketColumn]);
					// Adjust bucket time to match xaxisTimes to prevent date shifting
					if (this.xaxisTimes.length > 0 && this.bucketColumn !== 'hour_bucket') {
						bucket.setHours(this.xaxisTimes[0].rawDate.getHours(), this.xaxisTimes[0].rawDate.getMinutes(), 0, 0);
					}
					const datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, {date: bucket}, true);
					
					if (datesIndex !== -1) {
						const grossSales = row.gross_sales / 100;
						const ordersCount = row.orders_cnt;
						
						// Update global series
						globalVolume[0].data[datesIndex] += grossSales;
						globalOrders[0].data[datesIndex] += ordersCount;
						
						// Update totals
						result.volumeTotalPrevious += grossSales;
						result.countTotalPrevious += ordersCount;
					}
				});
				
				// Process previous period payment types for transactions
				if (this.previousAggregatedData.type) {
					this.previousAggregatedData.type.forEach(row => {
						const bucket = new Date(row[this.bucketColumn]);
						// Adjust bucket time to match xaxisTimes to prevent date shifting
						if (this.xaxisTimes.length > 0 && this.bucketColumn !== 'hour_bucket') {
							bucket.setHours(this.xaxisTimes[0].rawDate.getHours(), this.xaxisTimes[0].rawDate.getMinutes(), 0, 0);
						}
						const datesIndex = this.analyticsStore.getDatesIndex(this.periodDates, this.xaxisTimes, {date: bucket}, true);
						
						if (datesIndex !== -1 && row.payment_type === 'stripe') {
							const grossSales = row.gross_sales / 100;
							const ordersCount = row.orders_cnt;
							
							transactionsVolume[0].data[datesIndex] += grossSales;
							transactionsCount[0].data[datesIndex] += ordersCount;
							result.transactionsVolumeTotalPrevious += grossSales;
							result.transactionsCountTotalPrevious += ordersCount;
						}
					});
				}
			}

			// Calculate best businesses (only if not aggregate-only)
			let bestBusinessVolume = null;
			let fallbackColors = ["#73b64a", "#fd8700", "#1da4f8",
				"#c739cb", "#e02a1f", "#fdc700"];
			let businessVolumeFallbackColors = {};
			let colorIndex = 0;
			if (!this.isAggregateOnly && Object.keys(businessesVolumeSeries).length > 0) {
				businessesVolumeSeries = Object.values(businessesVolumeSeries);
				businessesVolumeSeries = businessesVolumeSeries.sort((a, b) => {
					let aTotal = a.data.reduce((acc, val) => acc + val, 0);
					let bTotal = b.data.reduce((acc, val) => acc + val, 0);
					return bTotal - aTotal;
				});
				businessesVolumeSeries = businessesVolumeSeries.slice(0, 6);
				result.bestBusinessVolumeColors = [];
				businessesVolumeSeries.forEach((b, index) => {
					if (!b.color) {
						b.color = fallbackColors[index];
					}
					result.bestBusinessVolumeColors.push(b.color);
				});

				if (businessesVolumeSeries.length > 0) {
					result.bestBusinessVolume = businessesVolumeSeries[0].data.reduce((acc, val) => acc + val, 0);
					result.bestBusinessVolumeName = businessesVolumeSeries[0].name;
					bestBusinessVolume = businessesVolumeSeries[0];
				}
			}
			let bestBusinessOrders = null;
			if (!this.isAggregateOnly && Object.keys(businessesOrdersSeries).length > 0) {
				businessesOrdersSeries = Object.values(businessesOrdersSeries);
				businessesOrdersSeries = businessesOrdersSeries.sort((a, b) => {
					let aTotal = a.data.reduce((acc, val) => acc + val, 0);
					let bTotal = b.data.reduce((acc, val) => acc + val, 0);
					return bTotal - aTotal;
				});
				businessesOrdersSeries = businessesOrdersSeries.slice(0, 6);
				result.bestBusinessOrdersColors = [];
				businessesOrdersSeries.forEach((b, index) => {
					if (!b.color) {
						b.color = fallbackColors[index];
					}
					result.bestBusinessOrdersColors.push(b.color);
				});

				if (businessesOrdersSeries.length > 0) {
					result.bestBusinessOrders = businessesOrdersSeries[0].data.reduce((acc, val) => acc + val, 0);
					result.bestBusinessOrdersName = businessesOrdersSeries[0].name;
					bestBusinessOrders = businessesOrdersSeries[0];
				}
			}
			let bestPaymentVolume = null;
			if (Object.keys(paymentsVolumeSeries).length > 0) {
				paymentsVolumeSeries = Object.values(paymentsVolumeSeries);
				paymentsVolumeSeries.forEach((a) => {
					a.total = a.data.reduce((acc, val) => acc + val, 0);
				});
				paymentsVolumeSeries = paymentsVolumeSeries.filter(v => v.total > 0).sort((a, b) => {
					return b.total - a.total;
				}).slice(0, 6);
				result.paymentsColors = paymentsVolumeSeries.map((a) => {
					let color = "#0752A3";
					if(a.hasOwnProperty('color')) {
						color = a.color;
					} else if(this.valuesStore.paymentsMethods.hasOwnProperty(a.payment_method)) {
						color = this.valuesStore.paymentsMethods[a.payment_method].color;
					}
					return color;
				});

				if(paymentsVolumeSeries.length > 0) {
					result.bestPaymentVolume = paymentsVolumeSeries[0].total;
					result.bestPaymentVolumeName = paymentsVolumeSeries[0].name;
					bestPaymentVolume = paymentsVolumeSeries[0];
				}
			}
			let bestPaymentOrders = null;
			if (Object.keys(paymentsOrdersSeries).length > 0) {
				paymentsOrdersSeries = Object.values(paymentsOrdersSeries);
				paymentsOrdersSeries.forEach((a) => {
					a.total = a.data.reduce((acc, val) => acc + val, 0);
				});
				paymentsOrdersSeries = paymentsOrdersSeries.filter(v => v.total > 0).sort((a, b) => {
					return b.total - a.total;
				}).slice(0, 6);
				result.paymentsColorsNum = paymentsOrdersSeries.map((a) => {
					let color = "#0752A3";
					if(a.hasOwnProperty('color')) {
						color = a.color;
					} else if(this.valuesStore.paymentsMethods.hasOwnProperty(a.payment_method)) {
						color = this.valuesStore.paymentsMethods[a.payment_method].color;
					}
					return color;
				});

				if(paymentsOrdersSeries.length > 0) {
					result.bestPaymentOrders = paymentsOrdersSeries[0].total;
					result.bestPaymentOrdersName = paymentsOrdersSeries[0].name;
					bestPaymentOrders = paymentsOrdersSeries[0];
				}
			}
			let bestOrderModeVolume = null;
			if (Object.keys(ordersModesVolumeSeries).length > 0) {
				ordersModesVolumeSeries = Object.values(ordersModesVolumeSeries);
				ordersModesVolumeSeries.forEach((a) => {
					a.total = a.data.reduce((acc, val) => acc + val, 0);
				});
				ordersModesVolumeSeries = ordersModesVolumeSeries.filter(v => v.total > 0).sort((a, b) => {
					return b.total - a.total;
				});
				result.modesColors = ordersModesVolumeSeries.map((a) => {
					return this.ordersModes[a.order_mode].color;
				});

				if(ordersModesVolumeSeries.length > 0) {
					result.bestOrderModeVolume = ordersModesVolumeSeries[0].total;
					result.bestOrderModeVolumeName = ordersModesVolumeSeries[0].name;
					bestOrderModeVolume = ordersModesVolumeSeries[0];
				}
			}
			let bestOrderModeOrders = null;
			if (Object.keys(ordersModesOrdersSeries).length > 0) {
				ordersModesOrdersSeries = Object.values(ordersModesOrdersSeries);
				ordersModesOrdersSeries.forEach((a) => {
					a.total = a.data.reduce((acc, val) => acc + val, 0);
				});
				ordersModesOrdersSeries = ordersModesOrdersSeries.filter(v => v.total > 0).sort((a, b) => {
					return b.total - a.total;
				});

				if(ordersModesOrdersSeries.length > 0) {
					result.bestOrderModeOrders = ordersModesOrdersSeries[0].total;
					result.bestOrderModeOrdersName = ordersModesOrdersSeries[0].name;
					bestOrderModeOrders = ordersModesOrdersSeries[0];
				}
			}

			// Calculate previous period values for best performers
			if (this.previousAggregatedData) {
				// Calculate business previous values
				if (bestBusinessVolume && this.previousAggregatedData.full) {
					this.previousAggregatedData.full.forEach(row => {
						if (row.business_id === bestBusinessVolume.business_id) {
							result.bestBusinessVolumePrevious += row.gross_sales / 100;
						}
					});
				}
				if (bestBusinessOrders && this.previousAggregatedData.full) {
					this.previousAggregatedData.full.forEach(row => {
						if (row.business_id === bestBusinessOrders.business_id) {
							result.bestBusinessOrdersPrevious += row.orders_cnt;
						}
					});
				}
				
				// Calculate payment type previous values
				if (bestPaymentVolume && this.previousAggregatedData.type) {
					this.previousAggregatedData.type.forEach(row => {
						if (row.payment_type === bestPaymentVolume.payment_method) {
							result.bestPaymentVolumePrevious += row.gross_sales / 100;
						}
					});
				}
				if (bestPaymentOrders && this.previousAggregatedData.type) {
					this.previousAggregatedData.type.forEach(row => {
						if (row.payment_type === bestPaymentOrders.payment_method) {
							result.bestPaymentOrdersPrevious += row.orders_cnt;
						}
					});
				}
				
				// Calculate order mode previous values
				if (bestOrderModeVolume && this.previousAggregatedData.mode) {
					this.previousAggregatedData.mode.forEach(row => {
						if (row.order_mode === bestOrderModeVolume.order_mode) {
							result.bestOrderModeVolumePrevious += row.gross_sales / 100;
						}
					});
				}
				if (bestOrderModeOrders && this.previousAggregatedData.mode) {
					this.previousAggregatedData.mode.forEach(row => {
						if (row.order_mode === bestOrderModeOrders.order_mode) {
							result.bestOrderModeOrdersPrevious += row.orders_cnt;
						}
					});
				}
			}

			// Check if series have any non-zero data
			const globalVolumeHasData = globalVolume[0].data.some(v => v > 0) || globalVolume[1].data.some(v => v > 0);
			const globalOrdersHasData = globalOrders[0].data.some(v => v > 0) || globalOrders[1].data.some(v => v > 0);
			const transactionsVolumeHasData = transactionsVolume[0].data.some(v => v > 0) || transactionsVolume[1].data.some(v => v > 0);
			const transactionsCountHasData = transactionsCount[0].data.some(v => v > 0) || transactionsCount[1].data.some(v => v > 0);
			
			let chartsObj = {
				globalVolume: globalVolumeHasData ? globalVolume : [],
				globalOrders: globalOrdersHasData ? globalOrders : [],
				transactionsVolume: transactionsVolumeHasData ? transactionsVolume : [],
				transactionsCount: transactionsCountHasData ? transactionsCount : [],
				businessesVolume: Array.isArray(businessesVolumeSeries) ? businessesVolumeSeries : [],
				businessesOrders: Array.isArray(businessesOrdersSeries) ? businessesOrdersSeries : [],
				paymentsVolume: Array.isArray(paymentsVolumeSeries) ? paymentsVolumeSeries : [],
				paymentsOrders: Array.isArray(paymentsOrdersSeries) ? paymentsOrdersSeries : [],
				ordersModesVolume: Array.isArray(ordersModesVolumeSeries) ? ordersModesVolumeSeries : [],
				ordersModesOrders: Array.isArray(ordersModesOrdersSeries) ? ordersModesOrdersSeries : [],
			};
			return Object.assign(result, chartsObj);
		},
	},
	methods: {
		resetCharts() {
			this.$refs['chart-gross-volume'].reset();
			this.$refs['chart-orders-volume'].reset();
			this.$refs['chart-businesses-volume'].reset();
			this.$refs['chart-businesses-orders'].reset();
			this.$refs['chart-mode-volume'].reset();
			this.$refs['chart-type-volume'].reset();
			this.$refs['chart-mode-orders'].reset();
			this.$refs['chart-type-orders'].reset();
		},

	},
}
</script>

<style lang="scss" scoped>
.charts-wrapper {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 100%;
	margin-bottom: calc(-1 * var(--main-padding));

	.chart-container {
		min-width: calc((100% - var(--main-padding)) / 2);
		max-width: calc((100% - var(--main-padding)) / 2);
		margin-bottom: var(--main-padding);

		&:deep(.chart-svg-container) {
			transition: min-height .35s ease-in-out;
			height: 200px;
		}

		&.expanded {
			min-width: 100%;
			max-width: 100%;

			&:deep(.chart-svg-container) {
				height: 350px;
			}
		}

		&:deep(.card-header h3) {
			font-size: 18px;
		}

	}

	@media (max-width: 768px) {
		justify-content: center;
		.chart-container {
			min-width: unset;
			max-width: 400px;
			width: 100%;

			&.expanded {
				max-width: 100%;
			}
		}
	}

	.super-chart {
		:deep(.card-header) {
			background-color: rgba(108, 51, 203, 0.15);
		}
	}
}
</style>